import api from "./client";
console.log("ok", api);

export const getFulfilmentDetailsByContainer = (containerNo, userId) =>
  api.get(`/api/fulfilment/container/${containerNo}`, {
    headers: {
      "x-user-id": userId
    }
  });

export const acceptFulfilmentSkus = (payload) =>
  api.post("/api/fulfilment/accept", payload);

// REPORT DAMAGED / SHORT-RECEIVED
export const reportDamagedSku = (payload) =>
  api.post("/api/fulfilment/report-damaged-sku", payload);

// ✅ RECOVER SHORT / DAMAGED (bring back into expected)
export const recoverShortSku = (payload) =>
  api.post("/api/fulfilment/recover-short", payload);
